let verticalSliders = false;
jQuery(document).ready(function(){
    verticalSliders = jQuery('.wp-block-vif-elevator');
    if(!verticalSliders.length) return;

    initVerticalSlidersStructure();
    initVerticalSlidersNavigation();

    checkVerticalSliderPosition();
    jQuery(window).resize(checkVerticalSliderPosition);

    checkVerticalSliderDisplaySlide();
    jQuery(window).scroll(checkVerticalSliderDisplaySlide);
})

function initVerticalSlidersStructure(){
    verticalSliders.each(function(){
        let currentSlider = jQuery(this);
        let sliderContainer = jQuery('<div/>').addClass('wp-block-vif-elevator-container');
        let imageContainer = jQuery('<div/>').addClass('wp-block-vif-elevator-images-container');
        let contentContainer = jQuery('<div/>').addClass('wp-block-vif-elevator-content-container');
        sliderContainer.append(imageContainer,contentContainer);
        currentSlider.find('.wp-block-vif-elevator-child').each(function(){
            let currentSlide = jQuery(this);
            let image = currentSlide.find('.elevator-child-image');
            let content = currentSlide.find('.elevator-child-content');
            imageContainer.append(
                jQuery('<div/>').addClass('wp-block-vif-elevator-slide-container').append(
                    image
                )
            );
            contentContainer.append(
                jQuery('<div/>').addClass('wp-block-vif-elevator-slide-container').append(
                    content.prepend(
                        image.clone()
                    )
                )
            );
        })
        currentSlider.append(sliderContainer);
        currentSlider.find('.elevator-wrapper').remove();
    })
}

function initVerticalSlidersNavigation(){
    verticalSliders.each(function(){
        let currentSlider = jQuery(this);
        let stepContainer = jQuery('<div/>').addClass('slider-navigation-steps');
        for(let cptStep=0; cptStep<currentSlider.find('.wp-block-vif-elevator-content-container>.wp-block-vif-elevator-slide-container').length; cptStep++){
            let step = jQuery('<span/>');
            if(cptStep===0) step.addClass('active');
            stepContainer.append(step);
            step.click(function(){
                let slideToGo = currentSlider.find('.wp-block-vif-elevator-content-container>.wp-block-vif-elevator-slide-container:nth-child('+(cptStep+1)+')');
                jQuery('html, body').animate({
                    scrollTop: slideToGo.offset().top-(jQuery(window).height()/2)+(slideToGo.height()/2)
                }, 300);
            })
        }
        currentSlider.append(stepContainer);
    })
}
function checkVerticalSliderPosition(){
    verticalSliders.each(function(){
        let currentSlider = jQuery(this);
        let stickyColumn = currentSlider.find('.wp-block-vif-elevator-images-container');
        let navigation = currentSlider.find('>.slider-navigation-steps');
        stickyColumn.css('top', 'calc(50% - '+(Math.floor(stickyColumn.height()/2))+'px)');
        navigation.css('top', 'calc(50% - '+(Math.floor(navigation.height()/2))+'px)');
    })
}

function checkVerticalSliderDisplaySlide(){
    let scrollTop = jQuery(window).scrollTop();
    verticalSliders.each(function(){
        let currentSlider = jQuery(this);
        let navigation = currentSlider.find('>.slider-navigation-steps');
        currentSlider.find('.wp-block-vif-elevator-content-container').find('>.wp-block-vif-elevator-slide-container').each(function(index, item){
            let currentSlide = jQuery(item);
            let slidePosition = Math.floor(currentSlide.offset().top-scrollTop);
            if(slidePosition<Math.floor(jQuery(window).height()/2)){
                currentSlide.addClass('active');
                currentSlider.find('.wp-block-vif-elevator-images-container>.wp-block-vif-elevator-slide-container:nth-child('+(index + 1)+')').addClass('active');
                navigation.find('>span:nth-child('+(index + 1)+')').addClass('active');
                navigation.find('>span:not(:nth-child('+(index+1)+'))').removeClass('active');
            }else{
                currentSlide.removeClass('active');
                currentSlider.find('.wp-block-vif-elevator-images-container>.wp-block-vif-elevator-slide-container:nth-child('+(index + 1)+')').removeClass('active');
                if(item===0) navigation.find('>span:nth-child('+(index + 1)+')').removeClass('active');
            }
        })
    })
}